import {
  CompanyDetailPageState,
  CreateCompanyAction,
  DeleteCompanyAction,
  UpdateCompanyDetailAction,
  UploadSSOConfigAction,
} from './types';
import { createSlice } from '../../../../utils/@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';
import { CompanyDetail, SsoConfiguration } from '../../../../types/models';
import { createManager } from '../../../../utils/redux-injectors';
import { companyDetailPageSaga } from './saga';
import { todayWithoutTime } from '../../../components/FormSharedSubDetailPageElements';
import { ILoadingStateWithData } from '../../../../types/reducerState';

const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

const initialPropertyState: ILoadingStateWithData<any> = {
  loading: false,
  error: false,
  data: null,
};

export const initialState: CompanyDetailPageState = {
  company: null,
  uploadSsoUrl: initialPropertyState,
  downloadSsoUrl: initialPropertyState,
  loading: true,
  error: false,
};

const slice = createSlice({
  name: 'companyDetailPage',
  initialState,
  reducers: {
    createCompany(state, action: PayloadAction<CreateCompanyAction>) {},
    createCompanySucceeded(state, action: PayloadAction<CompanyDetail>) {
      state.company = action.payload;
    },
    deleteCompany(state, action: PayloadAction<DeleteCompanyAction>) {},
    downloadSSOConfig(state, action: PayloadAction<string>) {
      state.downloadSsoUrl = {
        ...state.downloadSsoUrl,
        loading: true,
      };
    },
    downloadSSOConfigSucceeded(state, action: PayloadAction<SsoConfiguration>) {
      state.downloadSsoUrl = {
        data: action.payload,
        error: false,
        loading: false,
      };
    },
    downloadSSOConfigFailed(state) {
      state.downloadSsoUrl = {
        data: null,
        error: true,
        loading: false,
      };
    },
    fetchCompanyDetail: (state, action: PayloadAction<string>) => initialState,
    fetchCompanyDetailSucceeded(state, action: PayloadAction<CompanyDetail>) {
      const isNew =
        !action.payload.connection ||
        action.payload.connection.id === EMPTY_GUID;
      state.loading = false;
      state.error = false;
      state.company = {
        ...action.payload,
        connection: isNew
          ? {
              ...action.payload.connection,
              id: 'Auto Generated',
              name: 'Auto Generated',
              auth_connection_id: 'Auto Generated',
              expiry: todayWithoutTime.toISOString(),
            }
          : action.payload.connection,
      };
    },
    fetchCompanyDetailFailed(state) {
      state.loading = false;
      state.error = true;
      state.company = null;
    },
    updateCompanyDetail(
      state,
      action: PayloadAction<UpdateCompanyDetailAction>,
    ) {
      //TODO:When need loading on save, can hook logic here.
    },
    updateCompanyDetailSucceeded(state, action: PayloadAction<CompanyDetail>) {
      state.company = action.payload;
    },
    uploadSSOConfig(state, action: PayloadAction<UploadSSOConfigAction>) {
      state.uploadSsoUrl = {
        ...state.downloadSsoUrl,
        loading: true,
      };
    },
    uploadSSOConfigSucceeded(state, action: PayloadAction<SsoConfiguration>) {
      state.uploadSsoUrl = {
        data: action.payload,
        error: false,
        loading: false,
      };
    },
    uploadSSOConfigFailed(state) {
      state.uploadSsoUrl = {
        data: null,
        error: true,
        loading: false,
      };
    },
    cleanup: () => initialState,
  },
});

export const {
  actions: companyDetailPageActions,
  reducer: companyDetailPageReducers,
} = slice;

export const useCompanyDetailPageSlice = () => ({ actions: slice.actions });

export const CompanyDetailPageManager = createManager({
  name: `${slice.name}Manager`,
  key: slice.name,
  reducer: slice.reducer,
  saga: companyDetailPageSaga,
});
